import { render, staticRenderFns } from "./home-banner-details.vue?vue&type=template&id=6aa49d1a&scoped=true&"
import script from "./home-banner-details.vue?vue&type=script&lang=js&"
export * from "./home-banner-details.vue?vue&type=script&lang=js&"
import style0 from "./home-banner-details.vue?vue&type=style&index=0&id=6aa49d1a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa49d1a",
  null
  
)

export default component.exports